
import { connect } from "react-redux";

import { post } from "../../actions/general";
import lazyComponent from "./lazy";

export default connect(null, { post })(lazyComponent);
